import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { AppRouteApi } from 'api';
import { IAppRoute } from 'types';

function useGetAll() {
  return useAuthQuery(getQueryKeys([KEY]).lists(), () => AppRouteApi.getAll(), {
    select: (data) => data.data as IAppRoute[],
  });
}

export default useGetAll;
